import {
  ConnectionFeature,
  ConnectionStatus,
  FacilityFeature,
} from "../api/graphql";
import { GetCurrentUserQuery } from "../GetCurrentUser.generated";

/**
 * Simple helper function to combine logic specific to a visitor/inmate
 * and messaging feature enablement
 */
export default function messagingEnabled(
  user: GetCurrentUserQuery["me"]
): boolean {
  if (user?.__typename === "Visitor")
    return user.connections
      .filter((c) => c.status === ConnectionStatus.Active)
      .some((c) => c.features.includes(ConnectionFeature.SendMessages));
  // inmates at a facility with messaging enabled should always see it
  // even if they don't have a relevant contact yet. we can always explain
  // why individual contacts aren't enabled later.
  if (user?.__typename === "Inmate")
    return user.facility.features.includes(FacilityFeature.Emessaging);

  return false;
}
